import ClientsStore from "./ClientList/ClientsStore";
import ClientDetailStore from "./ClientDetail/ClientDetailStore";
import ClientOverviewStore from "./ClientDetail/ClientOverviewStore";
import ClientRiskStore from "./ClientRisk/ClientRiskStore";
import ClientInquiryAnswersStore from "./ClientInquiries/ClientInquiryAnswersStore";
import InquiryQueueStore from "./InquiryQueue/InquiryQueueStore";
import InquiryDeliveryStore from "./InquiryQueue/InquiryDeliveryStore";
import ClientTicketsStore from "../tickets/ClientTicketsStore";
import ContractsStore from "./Contracts/ContractsStore";
import OnboardingStore from "./Onboarding/OnboardingStore";

const clientsStoreList = [
  { name: "clientsViewStore", store: ClientsStore },
  { name: "clientDetailStore", store: ClientDetailStore },
  // Client 360's Overview read, pinned to the open client by the ClientDetail
  // route. NOT "clientOverviewStore": that is the `client-overview` ServiceStore's.
  { name: "clientOverviewViewStore", store: ClientOverviewStore },
  { name: "clientRiskStore", store: ClientRiskStore },
  // Two instances of one class: the Client Inquiries page, and the Client 360
  // "Inquiries" tab (pinned to that client by the ClientDetail route).
  { name: "clientInquiryAnswersViewStore", store: ClientInquiryAnswersStore },
  { name: "clientInquiryAnswersTabStore", store: ClientInquiryAnswersStore },
  // The questions before they reach the client (Clients → Inquiry Queue).
  { name: "inquiryQueueViewStore", store: InquiryQueueStore },
  // [hub] H3: the same store again, in `mine` mode (Clients → My questions).
  { name: "myQuestionsViewStore", store: InquiryQueueStore },
  // The question open in either dialog, on its way to the client: its PDF and email (#4211, #17).
  { name: "inquiryDeliveryStore", store: InquiryDeliveryStore },
  // Client 360's Tickets tab — every ticket about the open client (pinned by
  // the ClientDetail route). NOT "ticketsStore": the `tickets` ServiceStore's.
  { name: "clientTicketsTabStore", store: ClientTicketsStore },
  // Blake's trackers (#3075 / #2663): two instances each — the cross-client
  // page, and the Client 360 tab pinned to the open client by the ClientDetail
  // route. NOT "clientContractsStore" / "clientOnboardingTasksStore": those are
  // the ServiceStores' keys.
  { name: "contractsViewStore", store: ContractsStore },
  { name: "clientContractsViewStore", store: ContractsStore },
  { name: "onboardingViewStore", store: OnboardingStore },
  { name: "clientOnboardingViewStore", store: OnboardingStore },
];

export default clientsStoreList;
